import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../../../utils/reduxHelper";

export const sourcingProductReduxAPI = createApi({
  reducerPath: "sourcingProductReduxAPI",
  baseQuery: baseQueryWithArgs,

  tagTypes: ["productDetails", "productColorOptions", "productVariants"],

  endpoints: (builder) => ({
    //GET Queries
    getProductDetails: builder.query({
      query: ({ productId, isBrandSourcing }) =>
        getQueryStringWithCreator(
          `s/getProductDetails?productId=${productId}&isBrandSourcing=${isBrandSourcing}`
        ),
      providesTags: ["productDetails"],
    }),
    getProductVariants: builder.query({
      query: ({ productId, isBrandSourcing }) => {
        return getQueryStringWithCreator(
          `s/getProductVariants?productId=${productId}&isBrandSourcing=${isBrandSourcing}`
        );
      },
      providesTags: ["productVariants"],
    }),
    getProductColorOptions: builder.query({
      query: ({ productId }) =>
        getQueryStringWithCreator(
          `s/getProductColorOptions?productId=${productId}`
        ),
      providesTags: ["productColorOptions"],
    }),
    getProductSizeChart: builder.query({
      query: ({ productId }) =>
        getQueryStringWithCreator(
          `s/getProductSizeChart?productId=${productId}`
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetProductDetailsQuery,
  useLazyGetProductVariantsQuery,
  useLazyGetProductColorOptionsQuery,
  useLazyGetProductSizeChartQuery,
} = sourcingProductReduxAPI;
